import React from "react";
import { FormProvider } from "react-hook-form";
import PropTypes from "prop-types";

import { Button, Modal } from "semantic-ui-react";

import useAsyncSteps from "./hooks/useAsyncSteps";
import useUserForm from "../hooks/useUserForm";
import ReassignTaskForm from "../ReassignTaskForm";
import UserForm from "../UserForm";

export function ReplaceUserAndReassignTasksModal({
  title,
  currentUserId,
  replaceUser,
  onClose,
}) {
  const { trigger } = useAsyncSteps();
  const formProps = useUserForm(replaceUser);

  return (
    <FormProvider {...formProps}>
      <Modal
        style={{ maxWidth: "360px" }}
        open
        data-test="user-and-replace-task-form-modal"
      >
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <form
            id="userAndReassignTaskForm"
            onSubmit={formProps.handleSubmit(
              ({ assigneeId, ...newUserInfo }) => {
                trigger({
                  toAssigner: assigneeId,
                  fromAssigner: currentUserId,
                  newUserInfo: newUserInfo,
                  successMessage: `Successfully ${
                    replaceUser ? "replaced user" : "reassigned tasks"
                  }`,
                });
                onClose();
              }
            )}
          >
            {replaceUser && <UserForm />}
            <div style={{ height: "110px" }}>
              <ReassignTaskForm
                currentUserId={currentUserId}
                defaultValue={replaceUser ? "newuser" : "unassigned"}
              />
            </div>
          </form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="Discard Changes"
            basic
            type="button"
            onClick={onClose}
          />
          <Button
            primary
            content="Finish"
            type="submit"
            form="userAndReassignTaskForm"
            disabled={!formProps.formState.isValid}
          />
        </Modal.Actions>
      </Modal>
    </FormProvider>
  );
}

ReplaceUserAndReassignTasksModal.propTypes = {
  title: PropTypes.string,
  currentUserId: PropTypes.string.isRequired,
  replaceUser: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ReplaceUserAndReassignTasksModal.defaultProps = {
  replaceUser: false,
  title: "",
};

export default ReplaceUserAndReassignTasksModal;
